import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

export const loadProducts = create(actions.LOAD_PRODUCTS_DATA);
export const setProductsStatus = create(actions.SET_PRODUCTS_STATUS);
export const setProductsData = create(actions.SET_PRODUCTS_DATA);

export const setIsStockOrder = create(actions.SET_IS_STOCK_ORDER);
